<template>
  <v-app theme="light" style="background-color: #0b7078ff">
    <nav-bar-vuetify />

    <VMain>
      <router-view  class="secondary--text"/>
    </VMain>
  </v-app>
</template>

<script>

export default {
  name: "App",
  data: () => ({
    //
  })
};
</script>
<style>
.v-application {
  font-family: Sarabun !important;
}
h1 {
  font-weight: bold;
  color:  var(--v-secondary-base)/*#3d2645*/;
  text-align: center;
}
.contentRow {
  margin-top: 20px;
  padding: 20px;
  width: 100%;
  margin-bottom: 30px;
  background-color:#fff/*#e3e3e3*/;
  border: 1px solid transparent;
  border-radius: 4px;
}
.container{
  max-width: 60%;
}
</style>